export default Object.freeze({
  GET_PROMISES: "GET_PROMISES"
});
